"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGovernance = exports.GovernanceModule = void 0;
var utils_1 = require("./utils");
var bootstrap_1 = require("../bootstrap");
var base_1 = __importDefault(require("./base"));
var GovernanceModule = (function (_super) {
    __extends(GovernanceModule, _super);
    function GovernanceModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GovernanceModule.prototype.submitProposal = function (proposal) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.post("/gov/proposals", proposal)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getProposals = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var qs, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        qs = utils_1.toQueryString(params);
                        return [4, this.client.get("/gov/proposals?" + qs)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.changeProposalParameter = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.post("/gov/proposals/param_change", body)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getProposal = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/proposals/" + id)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getProposalProposer = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/proposals/" + id + "/proposer")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getProposalDeposits = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/proposals/" + id + "/deposits")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.depositTokensProposal = function (id, body) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.post("/gov/proposals/" + id + "/deposits", body)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getDepositAt = function (id, depositorAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/proposals/" + id + "/deposits/" + depositorAddr)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getProposalVotes = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/proposals/" + id + "/votes")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.voteProposal = function (id, vote) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.post("/gov/proposals/" + id + "/votes", vote)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getProposalVote = function (id, voterAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/proposals/" + id + "/votes/" + voterAddr)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getProposalTallyResult = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/proposals/" + id + "/tally")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getDepositParameters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/parameters/deposit")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getTallyParameters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/parameters/tallying")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    GovernanceModule.prototype.getVotingParameters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/gov/parameters/voting")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    return GovernanceModule;
}(base_1.default));
exports.GovernanceModule = GovernanceModule;
var governanceModule;
function useGovernance() {
    var config = bootstrap_1.getConfig();
    if (!config)
        throw new Error('No client available');
    if (!governanceModule) {
        governanceModule = new GovernanceModule(config.restUrl);
    }
    return governanceModule;
}
exports.useGovernance = useGovernance;
//# sourceMappingURL=governance.js.map